import { axiosIntance } from '../../../config/ApiConfig';

export const InvoiceRepository = {
  makePayment: (form: object) => {
    return axiosIntance.post('/invoice/payment/make', form);
  }
};
